exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".iframe-padding {\n  padding-left: 18px; }\n\n.main-div {\n  overflow: hidden;\n  display: block;\n  height: 100%;\n  width: 100%; }\n\n.span-margin {\n  margin-left: 12px; }\n\n.header-margin {\n  margin-top: 1rem;\n  margin-left: 12px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/hcsp-dashboard/hcsp-dashboard-embed.scss
// module id = 5VkR
// module chunks = 0